import { Grid } from '@mui/material';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { loadExteriorImg } from '../../../../redux/agreement/actions';
import Modeldetails from './ModelDetails/ModelDetails';
import styles from './OptionContent.module.scss';
import PlanOption from './PlanOption/PlanOption';
const OptionContent = ({
	optionCheck,
	setOptionCheck,
	setTotalOptionPrice,
	totalOptionPrice,
}) => {
	return (
		<Grid container className={styles.optionContentWrapper}>
			<Grid item xs={5}>
				<Modeldetails totalOptionPrice={totalOptionPrice} />
			</Grid>
			<Grid item xs={7}>
				<PlanOption
					optionCheck={optionCheck}
					setOptionCheck={setOptionCheck}
					setTotalOptionPrice={setTotalOptionPrice}
				/>
			</Grid>
		</Grid>
	);
};

export default OptionContent;
